import React from 'react'
import { Dialog } from '@material-ui/core'
import { Row, Col } from 'react-bootstrap'
import DialogView from '../../../Dialogos/DialogView'
import { DialogConfirmacionContent } from '../../../Dialogos/DialogConfirmacionContent'
import { COLORES } from '../../../../config/colores'
import { parseEntityName } from '../../../../models/entity'

function ConfirmacionGuardadoSimulacion (props) {
  const { simulaciones, openSave, handleSave, handleCloseSave, exportadores } = props

  const detalleSimulaciones = () => {
    const simulacionesExportador = simulaciones.filter(
      (sim) => sim.exportador !== 'POOL'
    )

    return exportadores.map((e) => {
      const proyecciones = simulacionesExportador.filter(s => s.exportador === e.exportador)
      const detalle = (
        <div key={e.exportador} style={{ margin: '8px auto' }}>
          <Col md={12} style={{ textAlign: 'left' }}>
            <span
              style={{
                fontWeight: 'bold',
                color: COLORES.violet
              }}
            >
              {parseEntityName(e.exportador)}
            </span>
          </Col>

          {/* Mapeo de simulaciones por exportador */}
          {proyecciones.map((p) => {
            if (p.cereal === 'TODOS') {
              return null
            }

            return (
              <Row key={p.id} style={{ margin: '5px 0' }}>
                <Col md={3} style={{ textAlign: 'left' }}>
                  <span style={{ fontWeight: 'bold', color: COLORES.grey }}>{p.fecha} </span>
                </Col>
                <Col md={3}>
                  <span style={{ fontWeight: 'bold', color: COLORES.grey }}>{p.cereal} </span>
                </Col>
                <Col md={3} style={{ textAlign: 'left' }}>
                    Cupos:
                  <span style={{ fontWeight: 'bold', color: COLORES.grey }}>
                    {(p.cuposSimulados > 0) ? p.cuposSimulados : ' - '}
                  </span>
                </Col>
                <Col md={3} style={{ textAlign: 'left' }}>
                    Cumplimiento:
                  <span style={{ fontWeight: 'bold', color: COLORES.grey }}>
                    {p.cumplimiento} %
                  </span>
                </Col>
              </Row>
            )
          })}
        </div>
      )
      return detalle
    })
  }

  return (
    <Dialog
      open={openSave}
      onClose={handleCloseSave}
      maxWidth='lg'
      fullWidth
    >
      <DialogView
        confirmCallback={handleSave}
        cancelCallback={handleCloseSave}
        content={<DialogConfirmacionContent message={detalleSimulaciones()} />}
      />
    </Dialog>
  )
}

export default ConfirmacionGuardadoSimulacion
